import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/category/korean', label: '韩漫' },
    { path: '/category/japanese', label: '日漫' },
    { path: '/category/chinese', label: '国漫' },
    { path: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-heart-fill text-primary-500 text-xl"></i>
            </div>
            <span className={`font-heading text-xl font-semibold transition-colors ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
              女神漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${isActive(link.path) ? (scrolled ? 'text-primary-500' : 'text-white') : (scrolled ? 'text-foreground-700' : 'text-white/80')}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => navigate('/category/korean')}
              className="flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line"></i>
              </div>
              开始阅读
            </button>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`text-xl ${scrolled ? 'text-foreground-950' : 'text-white'} ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </div>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${isActive(link.path) ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'}`}
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={() => { navigate('/category/korean'); setMobileMenuOpen(false); }}
              className="mt-2 flex items-center justify-center gap-1.5 px-4 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line"></i>
              </div>
              开始阅读
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}